import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Layout, MainContainer, TopPointsContainer, TopPointsCard, Heading, FitnessActivityCard } from './style';
import LeaderbordNameHeader from '../NameHeader/leaderboardNameHeader';
import BuddiesData from './topBuddiesData';
import FitnessActivityData from './fitnessActivityData';
import {
  getUserId,
  getTopFitnessLeaderboard,
  getTopSocialUsers,
  getTopFitnessUsers,
  getTopWellnessUsers,
  getTopUserTotalPoints,
  getCompanyTotalTeamPoints,
  getTotalTeamUsersPoints,
  fetchTeamIcons,
  fetchCompanyTeamsCount,
  fetchCompanyTeamAndMyTeamFlags,
  getUserLeaderboardPoints,
  fetchMonthlyRewardsPoint, 
  getCompanyRank
} from '../../redux/actions';
import { findMonth, getActivityDate, commaSeperator, getInitials } from '../../utils/methods';
import { Waiting } from '../../components';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { ImageUrl } from '../../utils/constants';
import { withTranslation } from 'react-i18next';
import LazyImage from '../common/LazyImage/LazyImage';
import { TeamIconWhite, TopCompanyIcon, TopCompanywhiteIcon, TeamIcon, TopBuddiesPoint, TopBuddiesPointWhite, FitnessPoint, FitnessPointWhite, SocialPoint, SocialPointWhite, WellnessPointIcon, WellnessPointIconWhite, TotalStepIcon, TotalStepwhiteIcon, TotalDistance, TotalDistanceWhiteIcon, TotalCalorieIcon, TotalCaloriesWhiteIcon, MonthPointIcon, OwnPointIcon,  Champsicon } from '../../utils/icons';
import { NameInitials } from '../Manager/styles';

// Design Constants
const THEME_ACTIVE_COLOR = '#D66D75';
const THEME_INACTIVE_TEXT = '#184A61';
const THEME_BORDER_COLOR = 'rgba(0,0,0,0.1)';

class Leaderboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeBuddiesPoints: "1",
      companyId: props.companyInfo.id || 1,
      userLimit: 10,
      pageNumber: 1,
      temp: 1,
      cardHeader: true,
      currentMonthName: ''
    }
  }

  componentDidMount() {
    const { companyId,userLimit, pageNumber } = this.state;
    
    
    const { fetchMonthlyRewardsPoint } = this.props;
    const {isNewReward,getTopFitnessLeaderboard, getTopUserTotalPoints, getUserLeaderboardPoints, getCompanyRank,getCompanyTotalTeamPoints } = this.props;
    

    // Fetch Leaderboard Data
    // getTopFitnessLeaderboard(companyId, pageNumber, userLimit,isNewReward);
    // getTopUserTotalPoints(companyId, pageNumber, userLimit);
    this.props.getUserId();
    // this.props.getCompanyTotalTeamPoints(companyId, pageNumber, userLimit);
    this.props.fetchTeamIcons();
    this.props.fetchCompanyTeamsCount(companyId);
    this.props.fetchCompanyTeamAndMyTeamFlags(companyId);
    // getUserLeaderboardPoints();
    // Fetch Stats Data
    // getCompanyRank(companyId);

    if (isNewReward !== undefined) {

      getTopFitnessLeaderboard(companyId, pageNumber, userLimit, isNewReward);
      getTopUserTotalPoints(companyId, pageNumber, userLimit, isNewReward);
      getCompanyRank(companyId, isNewReward);
      getCompanyTotalTeamPoints(companyId, pageNumber, userLimit, isNewReward);
      getUserLeaderboardPoints(isNewReward);
  
      let currentMonth = moment().startOf("month").format('MMMM');
      let currentYear = moment().startOf('year').format('YYYY');
      let obj = getActivityDate(currentMonth.slice(0, 3), currentYear);
      fetchMonthlyRewardsPoint(obj.startDate, isNewReward);
    }

    const d = new Date();
    const month = findMonth(d.getMonth());
    this.setState({ currentMonthName: month });
  }

  componentDidUpdate(prevProps) {
    const { isNewReward,getTopFitnessLeaderboard,getCompanyTotalTeamPoints, fetchMonthlyRewardsPoint, getTopUserTotalPoints, getUserLeaderboardPoints, getCompanyRank } = this.props;

    const { companyId, userLimit, pageNumber } = this.state;

    if (prevProps.isNewReward !== isNewReward && isNewReward !== undefined) {
      getTopFitnessLeaderboard(companyId, pageNumber, userLimit, isNewReward);
      getTopUserTotalPoints(companyId, pageNumber, userLimit,isNewReward);
      getCompanyRank(companyId,isNewReward);
      getCompanyTotalTeamPoints(companyId, pageNumber, userLimit,isNewReward);
      getUserLeaderboardPoints(isNewReward);
      let currentMonth = moment().startOf("month").format('MMMM');
      let currentYear = moment().startOf('year').format('YYYY');
      let obj = getActivityDate(currentMonth.slice(0, 3), currentYear);
      fetchMonthlyRewardsPoint(obj.startDate,isNewReward);
    }
    if (this.props.wellnessCount && this.props.wellnessCount.company_team && this.state.cardHeader) {
      this.setState({
        activeBuddiesPoints: "9",
        cardHeader: false
      })
    }
  }

  callTopBuddiesPointsAPI = () => {
    const { companyId, userLimit, pageNumber, activeBuddiesPoints } = this.state;
    const { getTopSocialUsers, getTopFitnessUsers, getTopWellnessUsers, getTopUserTotalPoints, getCompanyTotalTeamPoints, getTotalTeamUsersPoints , isNewReward} = this.props;

    switch (activeBuddiesPoints) {
    case "1": getTopUserTotalPoints(companyId, pageNumber, userLimit, isNewReward); break;
    case "2": getTopFitnessUsers(companyId, pageNumber, userLimit,isNewReward); break;
    case "3": getTopSocialUsers(companyId, pageNumber, userLimit,isNewReward); break;
    case "4": getTopWellnessUsers(companyId, pageNumber, userLimit,isNewReward); break;
    case "9": getCompanyTotalTeamPoints(companyId, pageNumber, userLimit,isNewReward); break;
    case "8": getTotalTeamUsersPoints(isNewReward); break;
    default: break;
    }
  }

  buddiesPointUpdate = (value) => {
    this.setState({
      activeBuddiesPoints: value,
      pageNumber: 1
    }, () => {
      this.callTopBuddiesPointsAPI();
    })
  }

  leaderboardLimit = () => {
    const { companyId, userLimit, temp, pageNumber, activeBuddiesPoints } = this.state;
    const { getTopFitnessLeaderboard,isNewReward } = this.props;

    this.setState({ pageNumber: this.state.pageNumber + temp });

    if (["1", "2", "3", "4", "8", "9"].includes(activeBuddiesPoints)) {
      this.callTopBuddiesPointsAPI();
    } else if (activeBuddiesPoints > "4") {
      getTopFitnessLeaderboard(companyId, pageNumber, userLimit,isNewReward);
    }
  }

  updateLimit = () => {
    const { temp } = this.state;
    this.setState({ pageNumber: this.state.pageNumber + temp });
  }

  renderSidebarItem = (id, label, InactiveComponent, ActiveComponent) => {
    const { activeBuddiesPoints } = this.state;
    const isActive = activeBuddiesPoints === id;

    return (
      <TopPointsCard
        onClick={() => this.buddiesPointUpdate(id)}
        color={isActive ? "#fff" : THEME_INACTIVE_TEXT}
        background={isActive ? THEME_ACTIVE_COLOR : '#fff'}
        border={isActive ? 'none' : `1px solid ${THEME_BORDER_COLOR}`}
        style={{ fontWeight: isActive ? '600' : '500' }}
      >
        <div>
          {isActive ? <ActiveComponent /> : <InactiveComponent />}
          <div>{label}</div>
        </div>
        <div>{isActive ? <div /> : null}</div>
      </TopPointsCard>
    );
  }

  buddiesPointsCards = () => {
    const { t, wellnessCount } = this.props;
    return (
      <TopPointsContainer>
        {wellnessCount?.company_team &&
          this.renderSidebarItem("9", t("Top Company Wellness Team"), TopCompanyIcon, TopCompanywhiteIcon)
        }
        {this.renderSidebarItem("8", t("My Wellness Teams"), TeamIcon, TeamIconWhite)}
        {this.renderSidebarItem("1", t("Top Buddies Total Points"), TopBuddiesPoint, TopBuddiesPointWhite)}
        {this.renderSidebarItem("2", t("Top Buddies Fitness Points"), FitnessPoint, FitnessPointWhite)}
        {this.renderSidebarItem("3", t("Top Buddies Social Points"), SocialPoint, SocialPointWhite)}
        {this.renderSidebarItem("4", t("Top Buddies Wellness Points"), WellnessPointIcon, WellnessPointIconWhite)}
      </TopPointsContainer>
    )
  }

  fallBack = (e) => {
    e.target.src = '/public/images/default.png'
  }

  renderFitnessActivityItem = (id, label, InactiveComponent, ActiveComponent, leaderBoardData) => {
    const { activeBuddiesPoints } = this.state;
    const isActive = activeBuddiesPoints === id;

    return (
      <FitnessActivityCard 
        onClick={() => this.buddiesPointUpdate(id)}
        color={isActive ? "#fff" : THEME_INACTIVE_TEXT}
        background={isActive ? THEME_ACTIVE_COLOR : '#fff'}
        border={isActive ? 'none' : `1px solid ${THEME_BORDER_COLOR}`}
        profileBorder={isActive ? '3px solid #fff' : `3px solid ${THEME_INACTIVE_TEXT}`}
      >
        <div>
          {isActive ? <ActiveComponent /> : <InactiveComponent />}
          <div>
            <div>{label}</div>
            <div>
              <div>
                {[0, 1, 2].map((i) => (
                  leaderBoardData && leaderBoardData[i] && (
                    leaderBoardData[i].profile_image === 'profile-Image/default.png' || !leaderBoardData[i].profile_image ? (
                      <NameInitials key={i} id="name-initials" isBg={"#FEFEFE"} style={{ width: '30px', height: '30px', fontSize: '10px', border:'1px solid #DCDCDC;' }}>
                        {getInitials(leaderBoardData[i].name || "")}
                      </NameInitials>
                    ) : (
                      <LazyImage
                        key={i}
                        onError={this.fallBack}
                        src={`${ImageUrl}/${leaderBoardData[i].profile_image}`}
                        alt="Profile"
                      />
                    )
                  )
                ))}

              </div>
            </div>
          </div>
        </div>
        <div>
          {isActive ? <div /> : null}
        </div>
      </FitnessActivityCard>
    )
  }

  fitnessLeaderboard = () => {
    const { distanceLeaderboard, stepsLeaderboard, caloriesLeaderboard, t } = this.props;

    if (isNull(distanceLeaderboard) || isUndefined(distanceLeaderboard) ||
      isNull(caloriesLeaderboard) || isUndefined(caloriesLeaderboard) ||
      isNull(stepsLeaderboard) || isUndefined(stepsLeaderboard)) {
      return <Waiting />
    }

    return (
      <TopPointsContainer  style={{background:'rgb(255, 255, 255)',padding:'5px 20px 5px', border:'0.75px solid #DCDCDC', borderRadius:'0px 0px 12px 12px', borderTop:'0'}}>
        <Heading>{t("Fitness Activity Leaderboard")}</Heading>
        {this.renderFitnessActivityItem("5", t("Steps Completed"), TotalStepIcon, TotalStepwhiteIcon, stepsLeaderboard)}
        {this.renderFitnessActivityItem("6", t("Calories Burned"), TotalCalorieIcon, TotalCaloriesWhiteIcon, caloriesLeaderboard)}
        {this.renderFitnessActivityItem("7", t("Distance Traveled"), TotalDistance, TotalDistanceWhiteIcon, distanceLeaderboard)}
      </TopPointsContainer>
    )
  }

  // Updated to render 3 distinct cards in a grid layout as per image
  renderUserStats = () => {
    const { t, monthlyRewardPoint, totalPoints, userTotalPoints, userRank } = this.props;
    const { currentMonthName } = this.state;

    // Common styles for the small stat cards
    const cardStyle = {
      background: '#fff',
      border: '0.75px solid #DCDCDC',
      borderRadius: '8px',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
    };

    const labelStyle = {
      fontSize: '16px',
      color: '#184A61',
      marginBottom: '4px',
      lineHeight: '1.2',
      fontWeight: '400'
    };

    const valueStyle = {
      fontSize: '16px',
      fontWeight: '700',
      color: '#184A61'
    };

    return (
      <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '16px',background: '#fff',  border: '0.75px solid  #DCDCDC', borderRadius: '12px' }}>
        <div style={{ background:'#D3DEF2',borderRadius:'8px 8px 0px 0px', padding:'16px' , display:'flex', alignItems:'center', gap:'16px'}}>
          <Champsicon />
          <div>
            <div style={{fontSize:'16px', fontWeight:'700', color:'#184A61',fontFamily:'lato'}}>{t("You're ranked #")}{!isUndefined(userRank.user_rank) ? userRank.user_rank : "0"}{t(" in Total XP")}</div>
            {/* <div style={valueStyle}>{!isUndefined(userRank.user_rank) ? userRank.user_rank : "0"}</div> */}
          </div>
        </div>
        {/* Row 1: Two cards side by side */}
        <div style={{ display: 'flex', gap: '16px', padding:'0 16px 16px' }}>
          {/* Monthly Points Card */}
          <div style={{ ...cardStyle, flex: 1 }}>
            
            <MonthPointIcon />
            <div>
              <div style={labelStyle}>{t(currentMonthName)} {t("Points")}</div>
              <div style={valueStyle}>{commaSeperator(monthlyRewardPoint)} XP</div>
            </div>
          </div>

          {/* Total Points Card */}
          <div style={{ ...cardStyle, flex: 1 }}>
            <OwnPointIcon />
            <div>
              <div style={labelStyle}> {t("My Total Points")}</div>
              <div style={valueStyle}>{totalPoints?.total ? `${commaSeperator(userTotalPoints?.my_points || 0)} XP` : '0 XP'}</div>
            </div>
          </div>
        </div>

        {/* Row 2: Rank Card Full Width */}
        
      </div>
    );
  }

  render() {
    const {
      history, fitnessLeaderboard, socialUserData, fitnessUserData, wellnessUserData,
      topUsersTotalPoints, getTopSocialUsers, getTopFitnessUsers, getTopWellnessUsers,
      getTopUserTotalPoints, distanceLeaderboard, getTopFitnessLeaderboard, stepsLeaderboard,
      caloriesLeaderboard, getCompanyTotalTeamPoints, companyTeamPoints, getTotalTeamUsersPoints,
      teamIconsData, fetchTeamIcons,isNewReward
    } = this.props;

    const { activeBuddiesPoints, companyId, pageNumber, userLimit } = this.state;

    if (isNull(fitnessLeaderboard) || isUndefined(fitnessLeaderboard) ||
      isNull(distanceLeaderboard) || isUndefined(distanceLeaderboard) ||
      isNull(caloriesLeaderboard) || isUndefined(caloriesLeaderboard) ||
      isNull(stepsLeaderboard) || isUndefined(stepsLeaderboard)) {
      return <Waiting />
    }

    return (
      <Layout>
        <div>
          <LeaderbordNameHeader companyId={companyId} />
          <div>
            <MainContainer style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
              
              {/* Left Column: Stats & Navigation - Removed global white wrapper to allow cards to be distinct */}
              <div style={{ width: "32%", minWidth: "280px", display: 'flex', flexDirection: 'column' }}>
                
                {/* 1. User Stats (Points & Rank) Grid */}
                {this.renderUserStats()}

                {/* 2. Navigation Cards */}
                <div style={{background:'rgb(255, 255, 255)',padding:'20px 20px 0', border:'0.75px solid #DCDCDC', borderRadius:'12px 12px 0px 0px', borderBottom:'0'}}>
                  {this.buddiesPointsCards()}
                </div>
                
                {/* 3. Secondary Leaderboard */}
                {this.props.companyBranding?.company_branding?.show_education ? this.fitnessLeaderboard() : null}
              </div>

              {/* Right Column: Main Leaderboard Data */}
              <div style={{ flex: '1', background: '#fff', padding: '20px', border: '0.75px solid  #DCDCDC', borderRadius: '12px' }}>
                {(activeBuddiesPoints <= "4" || activeBuddiesPoints == "8" || activeBuddiesPoints == "9") ?
                  <BuddiesData
                    history={history}
                    topUsersTotalPoints={topUsersTotalPoints}
                    wellnessUserData={wellnessUserData}
                    fitnessUserData={fitnessUserData}
                    socialUserData={socialUserData}
                    activeBuddiesPoints={activeBuddiesPoints}
                    companyTeamPoints={companyTeamPoints}
                    teamIconsData={teamIconsData}
                    leaderboardLimit={this.leaderboardLimit}
                    pageNumber={pageNumber}
                    getTopSocialUsers={getTopSocialUsers}
                    getTopFitnessUsers={getTopFitnessUsers}
                    getTopWellnessUsers={getTopWellnessUsers}
                    getTopUserTotalPoints={getTopUserTotalPoints}
                    isNewReward={isNewReward}
                    getCompanyTotalTeamPoints={getCompanyTotalTeamPoints}
                    getTotalTeamUsersPoints={getTotalTeamUsersPoints}
                    fetchTeamIcons={fetchTeamIcons}
                    userLimit={userLimit}
                    companyId={companyId}
                    updateLimit={this.updateLimit}
                  /> :
                  <FitnessActivityData
                    isNewReward={isNewReward}
                    history={history}
                    fitnessLeaderboard={fitnessLeaderboard}
                    activeBuddiesPoints={activeBuddiesPoints}
                    leaderboardLimit={this.leaderboardLimit}
                    userLimit={userLimit}
                    companyId={companyId}
                    updateLimit={this.updateLimit}
                    pageNumber={pageNumber}
                    getTopFitnessLeaderboard={getTopFitnessLeaderboard}
                    distanceLeaderboard={distanceLeaderboard}
                    stepsLeaderboard={stepsLeaderboard}
                    caloriesLeaderboard={caloriesLeaderboard}
                  />
                }
              </div>
            </MainContainer>
          </div>
        </div>
      </Layout>
    )
  }
}

Leaderboard.defaultProps = {
  companyInfo: { id: 1, name: '' }
}

Leaderboard.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object,
  fitnessLeaderboard: PropTypes.object,
  wellnessUserData: PropTypes.object,
  fitnessUserData: PropTypes.object,
  socialUserData: PropTypes.object,
  topUsersTotalPoints: PropTypes.object,
  companyTeamPoints: PropTypes.object,
  teamUsersPoints: PropTypes.array,
  teamIconsData: PropTypes.object,
  teamsCount: PropTypes.array,
  wellnessCount: PropTypes.object,
  getUserId: PropTypes.func.isRequired,
  userId: PropTypes.number,
  getTopFitnessLeaderboard: PropTypes.func,
  getTopSocialUsers: PropTypes.func,
  getTopFitnessUsers: PropTypes.func,
  getTopWellnessUsers: PropTypes.func,
  getTopUserTotalPoints: PropTypes.func,
  getCompanyTotalTeamPoints: PropTypes.func,
  getTotalTeamUsersPoints: PropTypes.func,
  fetchCompanyTeamsCount: PropTypes.func,
  fetchCompanyTeamAndMyTeamFlags: PropTypes.func,
  fetchTeamIcons: PropTypes.func,
  distanceLeaderboard: PropTypes.object,
  stepsLeaderboard: PropTypes.object,
  caloriesLeaderboard: PropTypes.object,
  t: PropTypes.func,
  getUserLeaderboardPoints: PropTypes.func,
  user: PropTypes.array,
  companyBranding: PropTypes.object,
  fetchMonthlyRewardsPoint: PropTypes.func,
  getCompanyRank: PropTypes.func,
  monthlyRewardPoint: PropTypes.number,
  isNewReward: PropTypes.number,
  totalPoints: PropTypes.object,
  userTotalPoints: PropTypes.object,
  userRank: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

const mapStateToProps = (state) => ({
  fitnessLeaderboard: state.companyDashboard.fitnessLeaderboard,
  wellnessUserData: state.companyDashboard.wellnessUserData,
  fitnessUserData: state.companyDashboard.fitnessUserData,
  socialUserData: state.companyDashboard.socialUserData,
  topUsersTotalPoints: state.companyDashboard.topUsersTotalPoints,
  companyTeamPoints: state.companyDashboard.companyTeamPoints,
  teamUsersPoints: state.companyDashboard.teamUsersPoints,
  userId: state.profileData.userId,
  distanceLeaderboard: state.companyDashboard.distanceLeaderboard,
  stepsLeaderboard: state.companyDashboard.stepsLeaderboard,
  caloriesLeaderboard: state.companyDashboard.caloriesLeaderboard,
  teamIconsData: state.companyDashboard.teamIconsData,
  teamsCount: state.companyDashboard.teamsCount,
  wellnessCount: state.companyDashboard.wellnessCount,
  user: state.profileData.user,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  totalPoints: state.wellnessDashboard.reward,
  userRank: state.companyDashboard.userRank,
  userTotalPoints: state.companyDashboard.userTotalPoints,
  isNewReward: state.profileData.userProfileFullData?.company_details?.is_new_rewards
});

const mapDispatchToProps = (dispatch) => ({
  getUserId: () => dispatch(getUserId()),
  getTopFitnessLeaderboard: (id, pageNumber, limit,isNewReward) => dispatch(getTopFitnessLeaderboard(id, pageNumber, limit,isNewReward)),
  getTopSocialUsers: (id, pageNumber, limit,isNewReward) => dispatch(getTopSocialUsers(id, pageNumber, limit,isNewReward)),
  getTopFitnessUsers: (id, pageNumber, limit,isNewReward) => dispatch(getTopFitnessUsers(id, pageNumber, limit,isNewReward)),
  getTopWellnessUsers: (id, pageNumber, limit,isNewReward) => dispatch(getTopWellnessUsers(id, pageNumber, limit,isNewReward)),
  getTopUserTotalPoints: (id, pageNumber, limit, isNewReward) => dispatch(getTopUserTotalPoints(id, pageNumber, limit, isNewReward)),
  getCompanyTotalTeamPoints: (id, pageNumber, limit, isNewReward) => dispatch(getCompanyTotalTeamPoints(id, pageNumber, limit, isNewReward)),
  getTotalTeamUsersPoints: (isNewReward) => dispatch(getTotalTeamUsersPoints(isNewReward)),
  fetchTeamIcons: () => dispatch(fetchTeamIcons()),
  fetchCompanyTeamsCount: (companyId) => dispatch(fetchCompanyTeamsCount(companyId)),
  fetchCompanyTeamAndMyTeamFlags: (companyId) => dispatch(fetchCompanyTeamAndMyTeamFlags(companyId)),
  getUserLeaderboardPoints: (isNewReward) => dispatch(getUserLeaderboardPoints(isNewReward)),
  fetchMonthlyRewardsPoint: (startDate,isNewReward) => dispatch(fetchMonthlyRewardsPoint(startDate,isNewReward)),
  getCompanyRank: (id,isNewReward) => dispatch(getCompanyRank(id,isNewReward))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Leaderboard));